(function () {
    'use strict';

    angular.module('Services').factory('CompanybySpendTableService', CompanybySpendTableService);

    CompanybySpendTableService.$inject = [
        'Shipments',
        'TableLiteFactory',
        '$q',
        '$filter'
    ];

    function CompanybySpendTableService(
        Shipments,
        TableLiteFactory,
        $q,
        $filter
    ) {
        return function (options) {
            let tableData = {};
            let activeFilters = {};
            let paginationFilter = {};
            let sortingFilter = { page: 0 };

            let tableStructure = {
                config: {
                    noFooter: true,
                    noExtraction: true,
                    noTopOptions: true,
                    tableHeight: '36em'
                },
                headers: [{
                    label: 'COMPANY',
                    viewName: 'company'
                }, {
                    label: 'AMOUNT MONTH',
                    viewName: 'amountMonth'
                }, {
                    label: 'AMOUNT YEAR',
                    viewName: 'amountYear'
                }],
                data: [],
                rowOnClick: function (data) {
                    options.rowClickFn('/reporting', { tab: 'company-by-spend', filter: data.customerName });
                }
            };

            const tableActions = new TableLiteFactory(tableStructure, {
                serviceCallback: Shipments.getAccountBySpend,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err);
                },
                defaultFilters: {
                    size: 10,
                    page: 0,
                    sort: 'amountMonth,desc'
                }
            });

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data, pagination) {
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row, index) {
                    row.company = row.company.name;
                    row.amountMonth = $filter('bbaCurrency')(row.amountMonth, row.currency);
                    row.amountYear = $filter('bbaCurrency')(row.amountYear, row.currency);
                    tableStructure.data.push(row);
                });
            }
            this.tableData = tableStructure;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/CompanybySpendTableService.js